import { faTriangleExclamation, faX } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './styles.scss';

export type AlertVariant = 'error' | 'warning' | 'info' | 'success';

export interface AlertProps {
  title: string;
  message: string;
  variant?: AlertVariant;
  onClose?: () => void;
}

export const Alert: React.FC<AlertProps> = ({ title, message, variant = 'error', onClose }) => {
  return (
    <div className={`alert alert-${variant}`}>
      <div className="alert-title">
        <FontAwesomeIcon icon={faTriangleExclamation} />
        <span>{title}</span>
      </div>
      <span className="alert-message">{message}</span>
      {onClose && (
        <button className="alert-close" onClick={onClose}>
          <FontAwesomeIcon icon={faX} />
        </button>
      )}
    </div>
  );
};
